export const sizeMap = {
  Small: 'Small size',
  Medium: 'Mid-size',
  Large: 'Large size',
};

export const searchResults = [
  {
    values: ['rolex 1908', '1908'],
    url: '/rolex/1908',
  },
  {
    values: [
      'rolex cosmograph daytona',
      'rolex daytona',
      'daytona',
      'cosmograph daytona',
      'cosmograph-daytona',
    ],
    url: '/rolex/cosmograph-daytona',
  },
  {
    values: ['rolex air king', 'air king', 'air-king'],
    url: '/rolex/air-king',
  },
  {
    values: [
      'rolex lady-datejust',
      'rolex lady datejust',
      'lady datejust',
      'lady-datejust',
    ],
    url: '/rolex/lady-datejust',
  },
  {
    values: ['rolex datejust', 'datejust'],
    url: '/rolex/datejust',
  },
  {
    values: ['rolex day-date', 'rolex day date', 'day date', 'day-date'],
    url: '/rolex/day-date',
  },
  {
    // Two Explorer families (Explorer + Explorer II) → the all-watches page.
    // Exact match only, so "montblanc explorer" still shows the fragrance.
    values: ['rolex explorer', 'rolex explorer ii', 'rolex explorer 2', 'explorer', 'explorer ii', 'explorer 2'],
    url: '/rolex/watches',
  },
  {
    values: [
      'rolex gmt master ii',
      'rolex gmt master',
      'gmt master ii',
      'gmt master',
      'gmt-master-ii',
      'gmt-master',
    ],
    url: '/rolex/gmt-master-ii',
  },
  {
    values: ['rolex oyster perpetual', 'oyster perpetual', 'oyster-perpetual'],
    url: '/rolex/oyster-perpetual',
  },
  {
    values: [
      'rolex sea dweller',
      'rolex sea-dweller',
      'sea dweller',
      'sea-dweller',
    ],
    url: '/rolex/sea-dweller',
  },
  {
    values: [
      'rolex sky dweller',
      'rolex sky-dweller',
      'sky dweller',
      'sky-dweller',
    ],
    url: '/rolex/sky-dweller',
  },
  {
    values: ['rolex submariner', 'submariner'],
    url: '/rolex/submariner',
  },
  {
    values: [
      'rolex yacht-master',
      'rolex yacht',
      'yacht-master',
      'yacht master',
    ],
    url: '/rolex/yacht-master',
  },
  {
    values: [
      'rolex deepsea',
      'deepsea',
    ],
    url: '/rolex/deepsea',
  },
];

export const WATCHES_PER_PAGE = 6;

export const ACCESSORIES_PER_PAGE = 12;

export const CALENDLY_USER_URI = 'https://api.calendly.com/users/31aebc53-6f36-40a3-a351-3a001d9c6034';

/** Regex to match an RMC number */
export const RMC_REGEX = /.*-(M[A-Za-z0-9]+-[A-Za-z0-9]+)$/;

/**
 * Map of family names to their banner sys_ids.
 * Used for watch imports.
 */
export const FAMILY_PUSH_BANNER_ID_MAP = {
  'Day-Date': '3mihjb830romU1VuVn07Tt',
  'Cosmograph Daytona': '1grW2L2PsoBcVdD5VvLkRO',
  'Sky-Dweller': 'OQig1CgdnLi5W4Ason7B5',
  'Lady-Datejust': '1fVPZvALdvydh52Z9KOCyr',
  'Air-King': '3CijzYWJjeLQRTeTsGJYcH',
  'Datejust': '6fISdzScRyNZ0UfyFoIzE7',
  'Explorer': '5XPhkd9tYxUDYrode8t5MK',
  'Oyster Perpetual': '5Krm03YekWqY6zEzSuv56n',
  'Submariner': '3r9Ik1SBpL4X3QQagFnRBr',
  'Yacht-Master': 'VaOx5GKcgCATg3YBR387X',
  'GMT-Master II': '7Jo5XYzzc0HQR4yMF5MgFI',
  '1908': '41EeW6Vf4CJOsSG2MSfsHj',
  'Sea-Dweller': 'rGripM1m8V1fPLBDeFiJv',
  'Deepsea': '6DLJ8eOYIa2u8pKkGEJz97',
};

/**
 * Sys ID of the "Keep Exploring" slider.
 * Used for watch imports.
 */
export const KEEP_EXPLORING_SYS_ID = '42NSsfWvJmrA3eeRBdwFu4';
